export enum Operations {
  LIKE = '=',
  EQ = '==',
  NEQ = '!=',
  GT = '>',
  GTE = '>=',
  LT = '<',
  LTE = '<=',
  IN = 'in',
}

export enum Orders {
  ascend = 'asc',
  descend = 'desc',
}
